import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(private navController: NavController) {}

  navigateToHome() {
    this.navController.navigateRoot(['/tabs/van']);
  }

  navigateToWelcome() {
    this.navController.navigateRoot(['/welcome']);
  }

  navigateToAdmin() {
    this.navController.navigateForward(['/admin']);
  }
}
